import * as _ from "lodash";
import {Pipe, PipeTransform} from "@angular/core";
import {  } from "";
import { VamTitularEntity } from "../../../vam/titulares/entities/vam_titulares_entity";

@Pipe({
    name: "dataFilterCedula"
})
export class DataFilterPipe1 implements PipeTransform {

    transform(array: VamTitularEntity[], query: string): any {
        if (query) {
            return _.filter(array, row=> (row.Cedula+"").indexOf((query)) > -1);
        }
        return array;
    }
}

@Pipe({
    name: "dataFilterCategoria"
})
export class DataFilterPipe2 implements PipeTransform {

    transform(array: VamTitularEntity[], query: string): any {
        if (query) {
            return _.filter(array, row=> row.Categoria == query);
        }
        return array;
    }
}

@Pipe({
  name: "dataFilterNombres"
})
export class DataFilterPipe3 implements PipeTransform {

  transform(array: VamTitularEntity[], query: string): any {
      if (query) {
          return _.filter(array, row=> ((row.PrimerNombre+"").toUpperCase()).indexOf((query.toUpperCase())) > -1 ||
          ((row.SegundoNombre+"").toUpperCase()).indexOf((query.toUpperCase())) > -1||
          ((row.ApellidoPaterno+"").toUpperCase()).indexOf((query.toUpperCase())) > -1||
          ((row.ApellidoMaterno+"").toUpperCase()).indexOf((query.toUpperCase())) > -1);
      }
      return array;
  }
}




// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/listados/listados.filter.ts